import { render, staticRenderFns } from "./EditorLayoutColumn.vue?vue&type=template&id=8f3c1af8&"
import script from "./EditorLayoutColumn.vue?vue&type=script&lang=js&"
export * from "./EditorLayoutColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports